import { useDebounceCallback } from 'shared/libs/debounce'

import { useEffect, useRef, useState } from 'react'

import { useSearchParams } from 'react-router-dom'

interface Params {
  paramKey: string
  withPage?: boolean
}
export default function useSearchParamInput({
  paramKey,
  withPage = false,
}: Params) {
  const [searchParams, setSearchParams] = useSearchParams()

  const [searchValue, setSearchValue] = useState(
    searchParams.get(paramKey) || '',
  )
  const myParam = searchParams.get(paramKey)
  const isTyping = useRef(false)

  const debounced = useDebounceCallback<(value: string | undefined) => void>(
    (value) => {
      if (value) {
        searchParams.set(paramKey, value)
      } else {
        searchParams.delete(paramKey)
      }
      if (withPage) searchParams.set('page', '1')
      setSearchParams(searchParams)
      isTyping.current = false
    },
    500,
  )

  const onChange = (value: string) => {
    isTyping.current = true
    setSearchValue(value)
    debounced(value)
  }

  useEffect(() => {
    if (isTyping.current === false) {
      setSearchValue(myParam || '')
    }
  }, [searchParams])

  return { onChange, searchValue }
}
